const drawerQuote = document.getElementById('lds-quote-drawer');
const drawerQuoteInner = drawerQuote.querySelector('.lds-quote-drawer_inner');
const overlayQuote = document.getElementById('lds-quote-overlay');
const closeBtnQuote = document.getElementById('CloseQuote');

const openDrawerQuote = () => {
  drawerQuote.classList.remove('translate-x-full');
  drawerQuote.classList.add('translate-x-0');

  overlayQuote.classList.remove('opacity-0', 'pointer-events-none');
  overlayQuote.classList.add('opacity-50');

  document.body.classList.add('overflow-hidden');
};

const closeDrawerQuote = () => {
  drawerQuote.classList.add('translate-x-full');
  drawerQuote.classList.remove('translate-x-0');

  overlayQuote.classList.remove('opacity-50');
  overlayQuote.classList.add('opacity-0');

  setTimeout(() => {
    overlayQuote.classList.add('pointer-events-none');
    document.body.classList.remove('overflow-hidden');
  }, 300);
};

// ouverture via bouton class
document.addEventListener('click', function (event) {
  if (event.target.closest('.lds-quote-toggle')) {
    openDrawerQuote();
  }
});

// fermeture via bouton
closeBtnQuote?.addEventListener('click', closeDrawerQuote);

// fermeture via clic en dehors de l'intérieur du drawerQuote
drawerQuote.addEventListener('click', (event) => {
  if (!drawerQuoteInner.contains(event.target)) {
    closeDrawerQuote();
  }
});

// Shopify édition : ouverture uniquement si section sélectionnée
if (window.Shopify && window.Shopify.designMode) {
  const sectionId = drawerQuote.dataset.sectionId;

  document.addEventListener('shopify:section:select', (event) => {
    if (event.detail.sectionId === sectionId) {
      openDrawerQuote();
    }
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.detail.sectionId === sectionId) {
      closeDrawerQuote();
    }
  });
}
